import { Cron } from '@modules/common/types';
import { OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM } from '@modules/subscribe/constants';
import { Box, Drawer } from '@mui/material';
import { SlackChannelInput } from 'generated/graphql';
import { ReactNode } from 'react';
import { useLocation } from 'react-router-dom';
import { useMount } from 'react-use';
import { SubscribeDrawerContentV2 } from './SubscribeDrawerContentV2';

interface SubscribeDrawerV2Props {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
  isSubscribed: boolean;
  isSaveButtonDisabled: boolean;
  onSaveSubscription: () => void;
  isSubscribeRequestInProgress: boolean;
  onUnsubscribeButtonClick: () => void;
  isUnsubscribeRequestInProgress: boolean;
  selectedSlackChannels: SlackChannelInput[];
  onSelectedSlackChannelsChange: (slackChannels: SlackChannelInput[]) => void;
  selectedEmails: string[];
  onSelectedEmailsChange: (emails: string[]) => void;
  cronSchedule: Cron | undefined;
  setCronSchedule: (cronValue: Cron) => void;
  savedCronValue: Cron;
  shouldShowRealtimeFrequency?: boolean;
  PDFReportingOptions?: {
    isPDFReportingIncluded?: boolean;
    setIsPDFReportingIncluded?: () => void;
  };
  headerNode: ReactNode;
  removeSubscription?: () => void;
  savedSlackChannels: SlackChannelInput[];
}

export const SubscribeDrawerV2 = ({
  isOpen,
  onClose,
  onOpen,
  ...props
}: SubscribeDrawerV2Props) => {
  const location = useLocation();
  const search = new URLSearchParams(location.search);
  const openDrawerSearchParam = search.get(OPEN_SUBSCRIBE_DRAWER_QUERY_PARAM);

  useMount(() => {
    if (openDrawerSearchParam === 'true' && !isOpen) {
      onOpen();
    }
  });

  return (
    <Drawer open={isOpen} anchor="right" onClose={onClose}>
      <Box width="40vw">
        <SubscribeDrawerContentV2 onClose={onClose} {...props} />
      </Box>
    </Drawer>
  );
};
